var cov_rsgkqfxbx = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/hoc/styles/index.ts",
      hash = "c7364d88a727d49a4d2b6e6c26cf6a2430ecd4cf",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/hoc/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 28
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "1": {
        start: {
          line: 8,
          column: 29
        },
        end: {
          line: 8,
          column: 65
        }
      },
      "2": {
        start: {
          line: 9,
          column: 30
        },
        end: {
          line: 9,
          column: 68
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var resizableLess = {};
var moveableLess = {};
var hidableLess = {};
import genaration from '../../utils/classname';
export var hidableClass = (cov_rsgkqfxbx.s[0]++, genaration(hidableLess, 'hidable'));
export var moveableClass = (cov_rsgkqfxbx.s[1]++, genaration(moveableLess, 'moveable'));
export var resizableClass = (cov_rsgkqfxbx.s[2]++, genaration(resizableLess, 'resizable'));